<style lang="stylus">
.film-card-rule
    min-height 100vh
    background #ffffff
    padding 15px 15px 0
    font-size 15px
    &.show-header
      padding-top 59px
    .close
        font-size 25px
        font-weight 100
        color rgba(0,0,0,0.4)
    ul
        padding-left 20px
        margin 0
        font-size 13px
        color rgb(121,125,130)
        li
            line-height 23px
        span
            color rgb(255,95,22)
        .applicable-cinema
            color rgb(71,122,172)
    .rule
        h3
            margin 0 0 5px 0
            font-size 14px
            font-weight normal
            color rgb(25,26,27)
            &:nth-child(3)
              margin-top 30px
    .limit-city
      margin-top 30px
</style>
<template>
  <div>
    <div v-if="tplType == 'film'">
      <div :class="[isApp ? '' : 'show-header' , 'film-card-rule']">
          <my-header class="header" v-show="!isApp">
              <div slot="title">使用规则</div>
              <div slot="right" class="close" @click="close" >&times;</div>
          </my-header>
          <div v-if="isMzvipCo">
            <h3>线上兑换</h3>
              <div v-if="useRangeType === 10002"><!-- 2D卡使用规则： -->
                  <ul>
                      <li v-show="isValidEqualCash">在苏打优选内最高可兑换<span>{{equalCash | price}}元</span>的非电影票商品（任意品类）{{count}}份，超过{{equalCash | price}}元需补差价。</li><!-- 这里 X元 = 等价物值 -->
                      <li v-show="!isValidEqualCash">不支持兑换其他商品</li>
                  </ul>
              </div>
              <div v-else><!-- 通卡使用规则 -->
                  <ul>
                      <li v-show="isValidEqualCash">在苏打优选内最高可兑换<span>{{equalCash | price}}元</span>的非电影票商品（任意品类）{{count}}份，超过{{equalCash | price}}元需补差价。</li><!-- ，这里 X元 = 等价物值 -->
                      <li v-show="!isValidEqualCash">不支持兑换其他商品</li>
                  </ul>
              </div>
          </div>
          <div class="rule" v-else v-show="count || uniqueCardId">
              <h3>线上兑换</h3>
              <div v-if="useRangeType === 10002"><!-- 2D卡使用规则： -->
                  <ul>
                      <li>{{areaText}}<span>{{maxConsumePrice | price}}元</span>的<span>2D</span>电影票{{count}}张，超过{{maxConsumePrice | price}}元需补差价。</li> <!-- 这里 X元 = 抵扣上限 -->
                      <li v-show="isValidEqualCash">{{areaText}}<span>{{equalCash | price}}元</span>的<span>3D</span>电影票{{count}}张，超过{{equalCash | price}}元需补差价。</li><!-- 这里 X元 = 等价物值，3D / IMAX / POLY MAX /... = 罗列所有非2D票品名称 -->
                      <li v-show="isLimitCity && isValidEqualCash">在其他城市最高可兑换<span>{{equalCash | price}}元</span>的<span>2D/3D任意</span>电影票{{count}}张，超过{{equalCash | price}}元需补差价。</li>
                      <li v-show="isValidEqualCash">在苏打优选内最高可兑换<span>{{equalCash | price}}元</span>的非电影票商品（任意品类）{{count}}份，超过{{equalCash | price}}元需补差价。</li><!-- 这里 X元 = 等价物值 -->
                      <li v-show="!isValidEqualCash">不支持兑换其他商品</li>
                  </ul>
              </div>
              <div v-else><!-- 通卡使用规则 -->
                  <ul>
                      <li>{{areaText}}<span>{{maxConsumePrice | price}}元</span>的<span>2D/3D任意</span>电影票{{count}}张，超过{{maxConsumePrice | price}}元需补差价。</li><!-- ，这里 X元 = 抵扣上限 -->
                      <li v-show="isLimitCity && isValidEqualCash">在其他城市最高可兑换<span>{{equalCash | price}}元</span>的<span>2D/3D任意</span>电影票{{count}}张，超过{{equalCash | price}}元需补差价。</li>
                      <li v-show="isValidEqualCash">在苏打优选内最高可兑换<span>{{equalCash | price}}元</span>的非电影票商品（任意品类）{{count}}份，超过{{equalCash | price}}元需补差价。</li><!-- ，这里 X元 = 等价物值 -->
                      <li v-show="!isValidEqualCash">不支持兑换其他商品</li>
                  </ul>
              </div>
              <h3>线下兑换</h3>
                <ul>
                  <li v-if="useRangeType === 10002">在影院前台最高可兑换<span>{{maxConsumePrice | price}}元</span>的电影票{{count}}张（仅限2D）。</li>
                  <li v-else>在影院前台最高可兑换<span>{{maxConsumePrice | price}}元</span>的2D/3D任意电影票{{count}}张。</li>
                  <li>点击查看<span class="applicable-cinema" @click="toCinema">线下可兑换影院。</span></li>
                </ul>
              <div class="limit-city" v-show="isLimitCity">
                <h3>指定城市</h3>
                  <ul v-show="isLimitCity">
                    <li>指定城市为：{{limitCities}}</li>
                  </ul>
              </div>
          </div>
      </div>
    </div>
    <div v-else-if="tplType == 'category'">
      <category-card-rule></category-card-rule>
    </div>
    <div v-else>
      <gift-card-rule></gift-card-rule>
    </div>
  </div>
</template>
<script>
    import myHeader from '../../components/header.vue'
    import {getHostName} from '../../util/function'
    import RSA from '../../util/RSA.js'
    import cookie from '../../lib/cookie'
    import CCONSTANT from '../../constant/cookie'
    import { mapState } from 'vuex'
    import op from 'object-path'
    import _ from 'underscore'
    import { app } from '../../util/platform'
    import categoryCardRule from './category_card_rule.vue'
    import giftCardRule from './gift_card_rule.vue'
    import CARD_CONSTANT from '../../constant/card'

    let rsa = new RSA()
    export default {
        data() {
            return {
              tplType: 'film'
            }
        },
        components: {
            'my-header': myHeader,
            'category-card-rule': categoryCardRule,
            'gift-card-rule': giftCardRule
        },
        methods: {
            close() {
              this.$router.go(-1)
            },
            toCinema() {
              const cardDetail = this.$store.state.card.cardDetail
              const contentData = cardDetail.contentData
              const isCityLimit = op(cardDetail).get('ticketInfo.isCityLimit')
              if (this.$route.query && this.$route.query.type) {
                const type = this.$route.query.type
                const content = encodeURIComponent(this.$route.query.content)
                this.$router.push(`/card/detail/limit/cinema?type=${type}&content=${content}&isCityLimit=${isCityLimit}&ticketCardType=${CARD_CONSTANT.TICKET_CARD_TYPE_COUNT}`)
                return
              } else if (contentData && contentData.type) {
                this.$router.push(`/card/detail/limit/cinema?type=${contentData.type}&content=${contentData.content}&isCityLimit=${isCityLimit}&ticketCardType=${CARD_CONSTANT.TICKET_CARD_TYPE_COUNT}`)
                return
              } else if (cardDetail.uniqueCardId) {
                this.$router.push(`/card/detail/limit/cinema?type=${3}&content=${encodeURIComponent(rsa.encrypt(cardDetail.uniqueCardId, 'base64'))}&isCityLimit=${isCityLimit}&ticketCardType=${CARD_CONSTANT.TICKET_CARD_TYPE_COUNT}`)
                return
              }
            }
        },
        computed: {
          ...mapState({
            count: state => op(state.card.cardDetail).get('count'),
            equalCash: state => op(state.card.cardDetail).get('equalCash'),
            useRangeType: state => op(state.card.cardDetail).get('ticketInfo.useRangeType'),
            maxConsumePrice: state => op(state.card.cardDetail).get('ticketInfo.maxConsumePrice'),
            uniqueCardId: state => op(state.card.cardDetail).get('uniqueCardId'),
            isCityLimit: state => op(state.card.cardDetail).get('ticketInfo.isCityLimit'),
          }),
          isMzvipCo() {
            return cookie(CCONSTANT.COOKIE_CO) === CCONSTANT.COOKIE_CO_IS_MZVIP
          },
          isApp() {
            return app.isMZFilm()
          },
          isLimitCity() {
            return this.isCityLimit === 1
          },
          areaText() {
            return `${this.isLimitCity ? '在指定城市' : '在全国范围内'}最高可兑换`
          },
          limitCities() {
            return this.$store.state.card.limitCity.reduce((result, city) => `${result}、${city.cityName}`, '').substring(1) || '--'
          },
          isValidEqualCash() {
            return this.equalCash > 0
          }
        },
        mounted() {
          const vm = this
          const query = this.$route.query

          if(this.isApp) {
            document.title = '使用规则'
          }

          // 通过APP跳转，取链接上附带的卡信息
          if (query && query.type) {
            const type = parseInt(query.type)
            const content = decodeURIComponent(query.content).replace(/\s/g, '+')

            // 获取卡信息和指定城市列表
            this.$store.dispatch('getCardDetail', {
              type,
              content
            })
            .then(result => {
              // 兼容处理品类卡使用规则
              if(result.displayType == 3 || !result.ticketInfo || _.isEmpty(result.ticketInfo)){
                return this.tplType = 'category'
              }

              // 兼容处理礼包卡使用规则
              if(result.displayType == 4){
                return this.tplType = 'gift'
              }

              // 如果有限定城市则获取指定城市列表
              if (vm.isLimitCity) {
                vm.$store.dispatch('getLimitCity', {
                  type,
                  content,
                }).catch(e => {
                  console.log(e)
                })
              }
            })
            .catch(e => {
              console.log(e)
            })
          } else {

            // H5跳转，使用已有的卡详情信息
            const cardDetail = this.$store.state.card.cardDetail
            if (vm.isLimitCity) {
              if (cardDetail.contentData && cardDetail.contentData.type) {
                vm.$store.dispatch('getLimitCity', {
                  type: parseInt(cardDetail.contentData.type),
                  content: decodeURIComponent(cardDetail.contentData.content).replace(/\s/g, '+'),
                }).catch(e => {
                  console.log(e)
                })
              } else {
                  vm.$store.dispatch('getLimitCity', {
                    type: 3,
                    content: rsa.encrypt(cardDetail.uniqueCardId,'base64'),
                  }).catch(e => {
                    console.log(e)
                  })
              }
            }
            vm.$nextTick(() => {
              if(!vm.$store.state.card.cardDetail.hasOwnProperty('count')){
                  vm.$router.go(-1)
              }
            })
          }
        }
    }
</script>
